import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleMinus, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, description, okText }) => {
  const { t } = useTranslation();
  if (!isOpen) return null; // Visa inte modalen om den inte är öppen

  return (
      <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-mute-25 p-6 flex flex-col gap-6 rounded-md shadow-lg text-center relative text-black max-w-lg mx-4">

        <div className="flex w-full justify-end">
          <button onClick={onClose} className="">
            <FontAwesomeIcon icon={faXmark} className="text-xl" />
          </button>
        </div>

        <div className="flex justify-center">
          <div className="bg-red-100 p-4 rounded-full flex justify-center items-center">
            <FontAwesomeIcon icon={faCircleMinus} className="text-red-500" size="2x" />
          </div>
        </div>

        <p className="text-base font-normal max-w-md self-center break-words whitespace-pre-wrap">{title}</p>
        {description ? (
          <p className="text-sm text-mute-600 max-w-md self-center">{description}</p>
        ) : null}
        <div className="flex justify-around gap-2 w-fit self-center">
          <button
            onClick={onClose}
            className="btn btn-outline-primary"
          >
            {t("confirm.cancel")}
          </button>
          <button
            onClick={onConfirm}
            className="btn btn-primary"
           >
           {okText ?? t("confirm.sure")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal
